import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getSummaryReport, postNumberVerification, postOtpVerification } from "../CertificateService";
// import "./style.css";

const LANGUAGES = [
  { value: "English", label: "English", native: "English" },
  { value: "Bengali", label: "Bengali", native: "বাংলা" },
  { value: "Nepali", label: "Nepali", native: "नेपाली" },
];

const CERTIFICATE_TYPES = {
  English: [
    "Residential",
    "Character",
    "Income",
    "Same Person",
    "Distance",
    "Caste Authentication",
    "Unmarried",
  ],
  Bengali: [
    "বাসস্থান",
    "চরিত্র",
    "আয়",
    "একই ব্যক্তি",
    "দূরত্ব",
    "জাতি যাচাইকরণ",
    "অবিবাহিত",
  ],
  Nepali: [
    "बसोबास",
    "चरित्र",
    "आय",
    "एउटै व्यक्ति",
    "दूरी",
    "जाति प्रमाणीकरण",
    "अविवाहित",
  ],
};

const CONTENT = {
  English: {
    eyebrow: "Gram Panchayat Citizen Services",
    title: "Apply online for a Gram Panchayat certificate",
    subtitle:
      "A simple, secure and completely free service for citizens of rural Bengal.",
    status: "Track application",
    search: "Verify certificate",
    languageTitle: "Choose your preferred language",
    languageHint: "The instructions below will update instantly.",
    serviceTitle: "Certificates available through this portal",
    serviceIntro:
      "Citizens of rural Bengal can apply for the following certificates free of charge at their respective Gram Panchayat.",
    documentTitle: "Documents required before you apply",
    uploadNote:
      "Keep one passport-size photograph in JPG format (maximum 100 KB) and two supporting documents for address and identity verification in PDF format (maximum 2 MB each).",
    specialNote:
      "For caste authentication, supporting caste documents from immediate or extended family members must be merged into one PDF file.",
    processTitle: "Processing and validity",
    processText:
      "Applications are normally disposed of within approximately 7 working days. The issued certificate remains valid for 6 months.",
    delayText:
      "Some Gram Panchayats may initially require additional processing time while online certificate services are being introduced.",
    startTitle: "Ready to apply?",
    startSubtitle: "Complete these three quick steps to begin.",
    stepOne: "Review the certificate and document requirements.",
    stepTwo: "Confirm that your photograph and PDFs are ready.",
    stepThree: "Verify your mobile number using a 4-digit OTP.",
    consent:
      "I want to apply to the Gram Panchayat Pradhan for a certificate and confirm that the required documents are ready for upload.",
    proceed: "Proceed to mobile verification",
    helpdesk: "Need technical help? Visit the Panchayat Helpdesk",
    modalEyebrow: "Secure mobile verification",
    modalTitle: "Citizen sign up",
    modalSubtitle: "We will send a 4-digit OTP to your mobile number.",
    mobileLabel: "Mobile number",
    mobilePlaceholder: "Enter 10-digit mobile number",
    otpLabel: "One-time password",
    otpPlaceholder: "Enter 4-digit OTP",
    sendOtp: "Send OTP",
    verify: "Verify and continue",
    resend: "Resend OTP",
    resendIn: "Resend OTP in",
    changeNumber: "Change mobile number",
    securityNote: "Your mobile number is used only for secure verification.",
  },
  Bengali: {
    eyebrow: "গ্রাম পঞ্চায়েত নাগরিক পরিষেবা",
    title: "গ্রাম পঞ্চায়েতের সার্টিফিকেটের জন্য অনলাইনে আবেদন করুন",
    subtitle:
      "গ্রামীণ বাংলার নাগরিকদের জন্য সহজ, নিরাপদ এবং সম্পূর্ণ বিনামূল্যের পরিষেবা।",
    status: "আবেদনের অবস্থা দেখুন",
    search: "সার্টিফিকেট যাচাই করুন",
    languageTitle: "আপনার পছন্দের ভাষা নির্বাচন করুন",
    languageHint: "নীচের নির্দেশাবলী সঙ্গে সঙ্গে পরিবর্তিত হবে।",
    serviceTitle: "এই পোর্টালে উপলব্ধ সার্টিফিকেট",
    serviceIntro:
      "গ্রামীণ বাংলার নাগরিকরা নিজ নিজ গ্রাম পঞ্চায়েতে বিনামূল্যে নিম্নলিখিত সার্টিফিকেটের জন্য আবেদন করতে পারবেন।",
    documentTitle: "আবেদনের আগে প্রয়োজনীয় নথি",
    uploadNote:
      "একটি পাসপোর্ট সাইজের ছবি JPG ফরম্যাটে (সর্বোচ্চ ১০০ KB) এবং ঠিকানা ও পরিচয় যাচাইয়ের জন্য দুটি সহায়ক নথি PDF ফরম্যাটে (প্রতিটি সর্বোচ্চ ২ MB) প্রস্তুত রাখুন।",
    specialNote:
      "জাতি যাচাইয়ের ক্ষেত্রে নিকট বা বর্ধিত পরিবারের সদস্যদের জাতি-সংক্রান্ত সমস্ত নথি একটি PDF ফাইলে সংযুক্ত করতে হবে।",
    processTitle: "প্রক্রিয়াকরণ ও বৈধতা",
    processText:
      "সাধারণত প্রায় ৭ কার্যদিবসের মধ্যে আবেদন নিষ্পত্তি করা হয়। জারি হওয়া সার্টিফিকেট ৬ মাস পর্যন্ত বৈধ থাকে।",
    delayText:
      "অনলাইন পরিষেবা চালুর প্রাথমিক পর্যায়ে কিছু গ্রাম পঞ্চায়েতে অতিরিক্ত সময় লাগতে পারে।",
    startTitle: "আবেদনের জন্য প্রস্তুত?",
    startSubtitle: "শুরু করতে এই তিনটি সহজ ধাপ সম্পূর্ণ করুন।",
    stepOne: "সার্টিফিকেট ও নথির প্রয়োজনীয়তা দেখুন।",
    stepTwo: "আপনার ছবি ও PDF নথি প্রস্তুত আছে কি না নিশ্চিত করুন।",
    stepThree: "৪ সংখ্যার OTP দিয়ে মোবাইল নম্বর যাচাই করুন।",
    consent:
      "আমি গ্রাম পঞ্চায়েত প্রধানের কাছে সার্টিফিকেটের জন্য আবেদন করতে চাই এবং প্রয়োজনীয় নথিগুলি আপলোডের জন্য প্রস্তুত আছে বলে নিশ্চিত করছি।",
    proceed: "মোবাইল যাচাইয়ের জন্য এগিয়ে যান",
    helpdesk: "কারিগরি সহায়তা দরকার? পঞ্চায়েত হেল্পডেস্কে যান",
    modalEyebrow: "নিরাপদ মোবাইল যাচাই",
    modalTitle: "নাগরিক নিবন্ধন",
    modalSubtitle: "আপনার মোবাইল নম্বরে ৪ সংখ্যার OTP পাঠানো হবে।",
    mobileLabel: "মোবাইল নম্বর",
    mobilePlaceholder: "১০ সংখ্যার মোবাইল নম্বর লিখুন",
    otpLabel: "ওয়ান-টাইম পাসওয়ার্ড",
    otpPlaceholder: "৪ সংখ্যার OTP লিখুন",
    sendOtp: "OTP পাঠান",
    verify: "যাচাই করে এগিয়ে যান",
    resend: "OTP আবার পাঠান",
    resendIn: "আবার OTP পাঠানো যাবে",
    changeNumber: "মোবাইল নম্বর পরিবর্তন করুন",
    securityNote: "আপনার মোবাইল নম্বর শুধুমাত্র নিরাপদ যাচাইয়ের জন্য ব্যবহার করা হবে।",
  },
  Nepali: {
    eyebrow: "ग्राम पञ्चायत नागरिक सेवा",
    title: "ग्राम पञ्चायत प्रमाणपत्रका लागि अनलाइन आवेदन गर्नुहोस्",
    subtitle:
      "ग्रामीण बंगालका नागरिकका लागि सरल, सुरक्षित र पूर्ण रूपमा निःशुल्क सेवा।",
    status: "आवेदनको स्थिति हेर्नुहोस्",
    search: "प्रमाणपत्र जाँच गर्नुहोस्",
    languageTitle: "आफ्नो मनपर्ने भाषा छान्नुहोस्",
    languageHint: "तलका निर्देशन तुरुन्त परिवर्तन हुनेछन्।",
    serviceTitle: "यस पोर्टलमा उपलब्ध प्रमाणपत्रहरू",
    serviceIntro:
      "ग्रामीण बंगालका नागरिकहरूले आफ्नो ग्राम पञ्चायतबाट निम्न प्रमाणपत्रका लागि निःशुल्क आवेदन गर्न सक्छन्।",
    documentTitle: "आवेदनअघि आवश्यक कागजात",
    uploadNote:
      "एउटा पासपोर्ट साइजको फोटो JPG ढाँचामा (अधिकतम १०० KB) र ठेगाना तथा पहिचान प्रमाणीकरणका लागि दुई सहयोगी कागजात PDF ढाँचामा (प्रत्येक अधिकतम २ MB) तयार राख्नुहोस्।",
    specialNote:
      "जाति प्रमाणीकरणका लागि नजिक वा विस्तारित परिवारका सदस्यको जातिसम्बन्धी कागजात एउटै PDF फाइलमा जोड्नुपर्छ।",
    processTitle: "प्रशोधन र वैधता",
    processText:
      "आवेदन सामान्यतया करिब ७ कार्यदिनभित्र निष्पादन गरिन्छ। जारी प्रमाणपत्र ६ महिनासम्म मान्य रहन्छ।",
    delayText:
      "अनलाइन सेवा सुरु भएको प्रारम्भिक चरणमा केही ग्राम पञ्चायतमा थप समय लाग्न सक्छ।",
    startTitle: "आवेदन गर्न तयार हुनुहुन्छ?",
    startSubtitle: "सुरु गर्न यी तीन सजिला चरण पूरा गर्नुहोस्।",
    stepOne: "प्रमाणपत्र र कागजातका आवश्यकता हेर्नुहोस्।",
    stepTwo: "आफ्नो फोटो र PDF कागजात तयार भएको पुष्टि गर्नुहोस्।",
    stepThree: "४ अङ्कको OTP प्रयोग गरी मोबाइल नम्बर प्रमाणीकरण गर्नुहोस्।",
    consent:
      "म ग्राम पञ्चायत प्रधानसमक्ष प्रमाणपत्रका लागि आवेदन गर्न चाहन्छु र आवश्यक कागजात अपलोडका लागि तयार छन् भनी पुष्टि गर्दछु।",
    proceed: "मोबाइल प्रमाणीकरणतर्फ जानुहोस्",
    helpdesk: "प्राविधिक सहायता चाहिन्छ? पञ्चायत हेल्पडेस्कमा जानुहोस्",
    modalEyebrow: "सुरक्षित मोबाइल प्रमाणीकरण",
    modalTitle: "नागरिक दर्ता",
    modalSubtitle: "तपाईंको मोबाइल नम्बरमा ४ अङ्कको OTP पठाइनेछ।",
    mobileLabel: "मोबाइल नम्बर",
    mobilePlaceholder: "१० अङ्कको मोबाइल नम्बर लेख्नुहोस्",
    otpLabel: "एकपटक प्रयोग हुने पासवर्ड",
    otpPlaceholder: "४ अङ्कको OTP लेख्नुहोस्",
    sendOtp: "OTP पठाउनुहोस्",
    verify: "प्रमाणीकरण गरी अगाडि बढ्नुहोस्",
    resend: "OTP पुनः पठाउनुहोस्",
    resendIn: "OTP पुनः पठाउन बाँकी",
    changeNumber: "मोबाइल नम्बर परिवर्तन गर्नुहोस्",
    securityNote: "तपाईंको मोबाइल नम्बर सुरक्षित प्रमाणीकरणका लागि मात्र प्रयोग गरिन्छ।",
  },
};

const DOCUMENTS = {
  English: [
    "Certificate issued by Gram Sansad Member",
    "Aadhaar Card",
    "Passport",
    "Driving Licence",
    "Election Commission Voter ID Card",
    "Ration Card with address",
    "CGHS/ECHS Card",
    "Address certificate with photograph from a government-recognised educational institution (students only)",
    "Income Tax PAN Card",
    "Current passbook of a Post Office or scheduled bank with photograph",
    "Photo Identity Card issued by Central/State Government or PSU",
    "MGNREGA card issued by the Government",
    "Photo Identity Card issued by a government-recognised educational institution (students only)",
    "Pensioner Card with photograph and address",
    "Kisan Passbook with photograph and address",
    "Current financial year tax receipt",
    "Other documents relevant to the requested certificate",
  ],
  Bengali: [
    "গ্রাম সংসদ সদস্যের দ্বারা জারি করা সার্টিফিকেট",
    "আধার কার্ড",
    "পাসপোর্ট",
    "ড্রাইভিং লাইসেন্স",
    "নির্বাচন কমিশনের ভোটার পরিচয়পত্র",
    "ঠিকানাসহ রেশন কার্ড",
    "CGHS/ECHS কার্ড",
    "সরকারি স্বীকৃত শিক্ষাপ্রতিষ্ঠান থেকে ছবিসহ ঠিকানার সার্টিফিকেট (শুধুমাত্র শিক্ষার্থীদের জন্য)",
    "আয়কর PAN কার্ড",
    "ছবিসহ পোস্ট অফিস বা নির্ধারিত ব্যাংকের বর্তমান পাসবই",
    "কেন্দ্রীয়/রাজ্য সরকার বা PSU কর্তৃক জারি করা ছবিসহ পরিচয়পত্র",
    "সরকার কর্তৃক জারি করা MGNREGA কার্ড",
    "সরকারি স্বীকৃত শিক্ষাপ্রতিষ্ঠানের ছবিসহ পরিচয়পত্র (শুধুমাত্র শিক্ষার্থীদের জন্য)",
    "ছবি ও ঠিকানাসহ পেনশনভোগী কার্ড",
    "ছবি ও ঠিকানাসহ কিষাণ পাসবই",
    "বর্তমান অর্থবছরের ট্যাক্স রসিদ",
    "প্রার্থিত সার্টিফিকেট-সংক্রান্ত অন্যান্য নথি",
  ],
  Nepali: [
    "ग्राम संसद सदस्यद्वारा जारी गरिएको प्रमाणपत्र",
    "आधार कार्ड",
    "पासपोर्ट",
    "ड्राइभिङ लाइसेन्स",
    "निर्वाचन आयोगको मतदाता परिचयपत्र",
    "ठेगानासहित राशन कार्ड",
    "CGHS/ECHS कार्ड",
    "सरकारी मान्यता प्राप्त शैक्षिक संस्थाबाट फोटोसहित ठेगानाको प्रमाणपत्र (विद्यार्थीका लागि मात्र)",
    "आयकर PAN कार्ड",
    "फोटोसहित हुलाक कार्यालय वा अनुसूचित बैंकको हालको पासबुक",
    "केन्द्रीय/राज्य सरकार वा PSU द्वारा जारी फोटो परिचयपत्र",
    "सरकारद्वारा जारी गरिएको MGNREGA कार्ड",
    "सरकारी मान्यता प्राप्त शैक्षिक संस्थाद्वारा जारी फोटो परिचयपत्र (विद्यार्थीका लागि मात्र)",
    "फोटो र ठेगानासहित पेन्सनर कार्ड",
    "फोटो र ठेगानासहित किसान पासबुक",
    "हालको आर्थिक वर्षको कर रसिद",
    "माग गरिएको प्रमाणपत्रसँग सम्बन्धित अन्य कागजात",
  ],
};

function Icon({ name, size = 22 }) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  const icons = {
    inbox: (
      <svg {...common}>
        <path d="M4 5.5h16v13H4z" />
        <path d="M4 14h4l2 2h4l2-2h4" />
      </svg>
    ),
    certificate: (
      <svg {...common}>
        <path d="M6 3h12v13H6z" />
        <path d="m9 21 3-2 3 2v-5H9z" />
        <path d="M9 7h6M9 10h6" />
      </svg>
    ),
    rejected: (
      <svg {...common}>
        <circle cx="12" cy="12" r="9" />
        <path d="m9 9 6 6M15 9l-6 6" />
      </svg>
    ),
    clock: (
      <svg {...common}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </svg>
    ),
    arrow: (
      <svg {...common}>
        <path d="M5 12h14M14 7l5 5-5 5" />
      </svg>
    ),
    search: (
      <svg {...common}>
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-4-4" />
      </svg>
    ),
    file: (
      <svg {...common}>
        <path d="M6 2.5h8l4 4V21H6z" />
        <path d="M14 2.5v5h4M9 12h6M9 16h6" />
      </svg>
    ),
    check: (
      <svg {...common}>
        <path d="m5 12 4 4L19 6" />
      </svg>
    ),
    shield: (
      <svg {...common}>
        <path d="M12 3 5 6v5c0 5 3 8 7 10 4-2 7-5 7-10V6z" />
        <path d="m9 12 2 2 4-4" />
      </svg>
    ),
    phone: (
      <svg {...common}>
        <rect x="7" y="2.5" width="10" height="19" rx="2" />
        <path d="M11 18.5h2" />
      </svg>
    ),
    close: (
      <svg {...common}>
        <path d="m6 6 12 12M18 6 6 18" />
      </svg>
    ),
    help: (
      <svg {...common}>
        <circle cx="12" cy="12" r="9" />
        <path d="M9.8 9a2.4 2.4 0 1 1 3.3 2.2c-.8.4-1.1.9-1.1 1.8M12 17h.01" />
      </svg>
    ),
  };

  return icons[name] || null;
}

function safeNumber(value) {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : 0;
}

const Login = ({ logo }) => {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const [globalData, setGlobalData] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [isSending, setIsSending] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);

  const copy = CONTENT[selectedLanguage];
  const documents = DOCUMENTS[selectedLanguage];
  const certificateTypes = CERTIFICATE_TYPES[selectedLanguage];

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(
      today.getDate()
    ).padStart(2, "0")}`;

    getSummaryReport(0, 0, 0, "01.01.2024", formattedDate)
      .then((result) => {
        setGlobalData(Array.isArray(result?.data) ? result.data : []);
      })
      .catch(() => {
        setGlobalData([]);
      });

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  useEffect(() => {
    if (!showModal) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") setShowModal(false);
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [showModal]);

  const totals = useMemo(
    () =>
      globalData.reduce(
        (acc, item) => ({
          apply: acc.apply + safeNumber(item?.apply),
          issued: acc.issued + safeNumber(item?.download),
          rejected: acc.rejected + safeNumber(item?.reject),
          pending: acc.pending + safeNumber(item?.inProgress),
        }),
        { apply: 0, issued: 0, rejected: 0, pending: 0 }
      ),
    [globalData]
  );

  const stats = [
    { label: "Applications received", value: totals.apply, icon: "inbox", tone: "green" },
    { label: "Certificates issued", value: totals.issued, icon: "certificate", tone: "blue" },
    { label: "Applications rejected", value: totals.rejected, icon: "rejected", tone: "red" },
    { label: "In progress", value: totals.pending, icon: "clock", tone: "amber" },
  ];

  const startResendTimer = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    setResendTimer(30);

    timerRef.current = setInterval(() => {
      setResendTimer((previous) => {
        if (previous <= 1) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          return 0;
        }
        return previous - 1;
      });
    }, 1000);
  };

  const handleMobileChange = (event) => {
    const value = event.target.value.replace(/\D/g, "").slice(0, 10);
    setMobileNumber(value);
  };

  const handleOtpChange = (event) => {
    const value = event.target.value.replace(/\D/g, "").slice(0, 4);
    setOtp(value);
  };

  const handleSendOtp = () => {
    if (!/^\d{10}$/.test(mobileNumber)) {
      toast.error("Please enter a valid 10-digit mobile number.");
      return;
    }

    setIsSending(true);
    postNumberVerification(mobileNumber, (response) => {
      setIsSending(false);
      if (Number(response?.StatusCode) === 0) {
        toast.success("OTP sent successfully.");
        setOtpSent(true);
        setOtp("");
        startResendTimer();
      } else {
        toast.error(response?.message || "Unable to send OTP. Please try again.");
      }
    });
  };

  const handleVerifyOtp = () => {
    if (!/^\d{4}$/.test(otp)) {
      toast.error("Please enter the 4-digit OTP.");
      return;
    }

    setIsVerifying(true);
    postOtpVerification(mobileNumber, otp, (response) => {
      setIsVerifying(false);
      if (Number(response?.StatusCode) === 0) {
        localStorage.setItem("Certificate_user", JSON.stringify({ mobile: mobileNumber }));
        toast.success("OTP verified successfully.");
        navigate("/add-certificate");
      } else {
        toast.error("Invalid OTP. Please check and try again.");
      }
    });
  };

  const resetMobile = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = null;
    setOtpSent(false);
    setOtp("");
    setResendTimer(0);
  };

  return (
    <div className="certificate-page">
      <ToastContainer position="top-center" autoClose={3500} newestOnTop />

      <div className="certificate-shell">
        <header className="certificate-hero">
          <div className="hero-decoration hero-decoration-one" />
          <div className="hero-decoration hero-decoration-two" />

          <div className="hero-copy">
            <div className="hero-brand-row">
              {logo ? <img className="hero-logo" src={logo} alt="Portal logo" /> : null}
              <span className="hero-eyebrow">
                <Icon name="shield" size={18} />
                {copy.eyebrow}
              </span>
            </div>

            <h1>{copy.title}</h1>
            <p>{copy.subtitle}</p>

            <div className="hero-actions">
              <button className="action-button action-button-primary" type="button" onClick={() => navigate("/status-of-application")}>
                <Icon name="clock" size={20} />
                <span>{copy.status}</span>
                <Icon name="arrow" size={18} />
              </button>
              <button className="action-button action-button-secondary" type="button" onClick={() => navigate("/certificate-check")}>
                <Icon name="search" size={20} />
                <span>{copy.search}</span>
              </button>
            </div>
          </div>

          <div className="hero-illustration" aria-hidden="true">
            <div className="document-card">
              <div className="document-topline" />
              <div className="document-line document-line-long" />
              <div className="document-line" />
              <div className="document-line document-line-short" />
              <div className="document-seal">
                <Icon name="check" size={34} />
              </div>
            </div>
            <div className="hero-float-card hero-float-card-one">
              <Icon name="shield" size={20} /> Secure
            </div>
            <div className="hero-float-card hero-float-card-two">
              <Icon name="file" size={20} /> Paperless
            </div>
          </div>
        </header>

        <section className="stats-grid" aria-label="Application summary">
          {stats.map((stat) => (
            <article className={`stat-card stat-${stat.tone}`} key={stat.label}>
              <span className="stat-icon">
                <Icon name={stat.icon} />
              </span>
              <div>
                <strong>{stat.value.toLocaleString("en-IN")}</strong>
                <span>{stat.label}</span>
              </div>
            </article>
          ))}
        </section>

        <main className="certificate-layout">
          <div className="certificate-main">
            <section className="content-card language-card">
              <div className="section-heading compact-heading">
                <div>
                  <span className="section-kicker">Language</span>
                  <h2>{copy.languageTitle}</h2>
                  <p>{copy.languageHint}</p>
                </div>
              </div>

              <div className="language-switcher" role="radiogroup" aria-label={copy.languageTitle}>
                {LANGUAGES.map((language) => (
                  <label
                    className={`language-option ${selectedLanguage === language.value ? "is-selected" : ""}`}
                    key={language.value}
                  >
                    <input
                      type="radio"
                      name="language"
                      value={language.value}
                      checked={selectedLanguage === language.value}
                      onChange={(event) => setSelectedLanguage(event.target.value)}
                    />
                    <span className="language-native">{language.native}</span>
                    <span className="language-label">{language.label}</span>
                    <span className="language-check">
                      <Icon name="check" size={15} />
                    </span>
                  </label>
                ))}
              </div>
            </section>

            <section className="content-card">
              <div className="section-heading">
                <span className="section-icon section-icon-green">
                  <Icon name="certificate" />
                </span>
                <div>
                  <span className="section-kicker">Available services</span>
                  <h2>{copy.serviceTitle}</h2>
                  <p>{copy.serviceIntro}</p>
                </div>
              </div>

              <div className="certificate-type-grid">
                {certificateTypes.map((type, index) => (
                  <div className="certificate-type" key={type}>
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    <strong>{type}</strong>
                    <Icon name="check" size={17} />
                  </div>
                ))}
              </div>
            </section>

            <section className="content-card">
              <div className="section-heading">
                <span className="section-icon section-icon-blue">
                  <Icon name="file" />
                </span>
                <div>
                  <span className="section-kicker">Document checklist</span>
                  <h2>{copy.documentTitle}</h2>
                </div>
              </div>

              <div className="upload-requirement">
                <span className="upload-requirement-icon">
                  <Icon name="file" size={24} />
                </span>
                <p>{copy.uploadNote}</p>
              </div>

              <div className="special-note">
                <strong>Important</strong>
                <span>{copy.specialNote}</span>
              </div>

              <div className="document-list">
                {documents.map((document) => (
                  <div className="document-item" key={document}>
                    <span className="document-check">
                      <Icon name="check" size={15} />
                    </span>
                    <span>{document}</span>
                  </div>
                ))}
              </div>
            </section>

            <section className="content-card process-card">
              <div className="process-icon">
                <Icon name="clock" size={30} />
              </div>
              <div>
                <span className="section-kicker">Service timeline</span>
                <h2>{copy.processTitle}</h2>
                <p>{copy.processText}</p>
                <div className="delay-note">{copy.delayText}</div>
              </div>
            </section>
          </div>

          <aside className="application-sidebar">
            <section className="application-card">
              <div className="application-card-header">
                <span className="application-card-icon">
                  <Icon name="shield" size={28} />
                </span>
                <div>
                  <span className="section-kicker">Start application</span>
                  <h2>{copy.startTitle}</h2>
                  <p>{copy.startSubtitle}</p>
                </div>
              </div>

              <ol className="application-steps">
                {[copy.stepOne, copy.stepTwo, copy.stepThree].map((step, index) => (
                  <li key={step}>
                    <span>{index + 1}</span>
                    <p>{step}</p>
                  </li>
                ))}
              </ol>

              <label className={`consent-box ${isChecked ? "is-checked" : ""}`}>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(event) => setIsChecked(event.target.checked)}
                />
                <span className="custom-checkbox">
                  <Icon name="check" size={15} />
                </span>
                <span>{copy.consent}</span>
              </label>

              <button
                className="proceed-button"
                type="button"
                disabled={!isChecked}
                onClick={() => setShowModal(true)}
              >
                <Icon name="phone" size={20} />
                <span>{copy.proceed}</span>
                <Icon name="arrow" size={18} />
              </button>

              <a className="helpdesk-link" href="https://helpdesk.wbprd.in/" target="_blank" rel="noopener noreferrer">
                <Icon name="help" size={19} />
                <span>{copy.helpdesk}</span>
              </a>
            </section>
          </aside>
        </main>
      </div>

      {showModal ? (
        <div className="modal-overlay" role="presentation" onMouseDown={() => setShowModal(false)}>
          <section
            className="otp-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="otp-modal-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <button className="modal-close" type="button" aria-label="Close" onClick={() => setShowModal(false)}>
              <Icon name="close" size={22} />
            </button>

            <div className="modal-icon">
              <Icon name="phone" size={30} />
            </div>
            <span className="modal-eyebrow">{copy.modalEyebrow}</span>
            <h2 id="otp-modal-title">{copy.modalTitle}</h2>
            <p className="modal-subtitle">{copy.modalSubtitle}</p>

            <div className="otp-form">
              <label htmlFor="citizen-mobile">{copy.mobileLabel}</label>
              <div className={`input-shell ${otpSent ? "is-readonly" : ""}`}>
                <span>+91</span>
                <input
                  id="citizen-mobile"
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel"
                  placeholder={copy.mobilePlaceholder}
                  value={mobileNumber}
                  onChange={handleMobileChange}
                  readOnly={otpSent}
                />
              </div>

              {!otpSent ? (
                <button className="modal-primary-button" type="button" onClick={handleSendOtp} disabled={isSending}>
                  {isSending ? <span className="button-spinner" /> : <Icon name="arrow" size={19} />}
                  {isSending ? "Sending..." : copy.sendOtp}
                </button>
              ) : (
                <>
                  <div className="mobile-confirmation">
                    <span>OTP sent to +91 {mobileNumber}</span>
                    <button type="button" onClick={resetMobile}>
                      {copy.changeNumber}
                    </button>
                  </div>

                  <label htmlFor="citizen-otp">{copy.otpLabel}</label>
                  <input
                    className="otp-input"
                    id="citizen-otp"
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    placeholder={copy.otpPlaceholder}
                    value={otp}
                    onChange={handleOtpChange}
                    maxLength={4}
                    autoFocus
                  />

                  <button className="modal-primary-button" type="button" onClick={handleVerifyOtp} disabled={isVerifying}>
                    {isVerifying ? <span className="button-spinner" /> : <Icon name="shield" size={19} />}
                    {isVerifying ? "Verifying..." : copy.verify}
                  </button>

                  <button
                    className="resend-button"
                    type="button"
                    onClick={handleSendOtp}
                    disabled={resendTimer > 0 || isSending}
                  >
                    {resendTimer > 0 ? `${copy.resendIn} ${resendTimer}s` : copy.resend}
                  </button>
                </>
              )}
            </div>

            <div className="modal-security-note">
              <Icon name="shield" size={17} />
              <span>{copy.securityNote}</span>
            </div>
          </section>
        </div>
      ) : null}
    </div>
  );
};

export default Login;
